import { uuid } from 'utils';
import { ICycle, IVisitorMessageType } from '../../entities/offsiteCampaign';
import { TFunction } from 'react-i18next';

interface CycleType {
  heading: string;
  defaultValue: ICycle;
}

const cycleTypeConfig: (t: TFunction<'campaigns'>) => { [key in IVisitorMessageType]: CycleType } = (
  t: TFunction<'campaigns'>,
) => ({
  email: {
    heading: t('cycle.email'),
    defaultValue: {
      messageType: 'email',
      templateId: undefined,
      delay: 0,
      id: uuid(),
      subjectLineId: '',
    },
  },
  browse: {
    heading: t('cycle.browse'),
    defaultValue: {
      messageType: 'browse',
      templateId: undefined,
      delay: 0,
      id: uuid(),
      subjectLineId: '',
    },
  },
  sms: {
    heading: t('cycle.sms'),
    defaultValue: {
      messageType: 'sms',
      templateId: undefined,
      delay: 0,
      id: uuid(),
      subjectLineId: '',
    },
  },
  whatsapp: {
    heading: t('cycle.whatsapp'),
    defaultValue: {
      messageType: 'whatsapp',
      templateId: undefined,
      delay: 0,
      id: uuid(),
      subjectLineId: '',
    },
  },
  rcs: {
    heading: t('cycle.rcs'),
    defaultValue: {
      messageType: 'rcs',
      templateId: undefined,
      delay: 0,
      id: uuid(),
      subjectLineId: '',
    },
  },
});

export function getCycleConfig(campaignType: IVisitorMessageType, translator: TFunction<'campaigns'>): CycleType {
  return cycleTypeConfig(translator)[campaignType];
}
